import _ from 'underscore'

export default {
  getLists: state => state.shoppinglists,
  getListById: (state, id) => {
    return _.findWhere(state.shoppinglists, { id: id })
  }
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js